(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AddInvoiceItemModalController', AddInvoiceItemModalController);

    AddInvoiceItemModalController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout', 'ServiceItemCustom', 'ServiceAddOnCustom', 'ServantCustom'];

    function AddInvoiceItemModalController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout, ServiceItemCustom, ServiceAddOnCustom, ServantCustom) {

        var vm = this;
        vm.invoiceInfoItems = [];
        vm.loadAll = loadAll;
        vm.itemSelectionType = "SERVICE";
        vm.onServiceChanged = onServiceChanged;
        vm.servant_changed = servant_changed;
        vm.canEditCapacity = true;
        vm.addServiceItem = addServiceItem;
        vm.serviceItemList = null;
        vm.onServiceItemClick = onServiceItemClick;
        vm.onServiceAddOnClick = onServiceAddOnClick;
        vm.deleteItem = deleteItem;
        vm.tabChanged = tabChanged;
        vm.noItemMsg = 'هیچ آیتمی انتخاب نشده است';
        vm.noServiceAddOnMsg = 'هیچ خدمت ویژه ای تعریف نشده است';
        vm.goToServiceAddOn = goToServiceAddOn;
        vm.allServants = [];

        vm.activityTypeInfo = {};
        vm.activityTypeInfo.servantTitle = "پرسنل";


        loadAll();


        vm.closeModal = closeModal;
        vm.okModal = okModal;

        vm.getModalTitle = getModalTitle;


        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);

            getAllActiveServants();
            getAllServiceItems();
            getAllServiceAddOns();

        }

        function okModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.close(vm.invoiceInfoItems);
            }
        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
                return;
            }
        }

        function getModalTitle() {
            return 'tikonApp.invoiceInfo.addInvoiceInfoItem.title';
        }


        function getAllServiceItems() {
            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (list) {
                vm.serviceItemList = list;
            })

        }


        function onServiceChanged() {

            // if(vm.selectedServiceItem)
            //     ;

        }

        function servant_changed() {

        }

        function updateServantList(then) {

            vm.servantList = [];
            if (vm.selectedServiceItem.id) {
                ServiceItemCustom.getServiceServants(vm.selectedServiceItem.id).query(function (servants) {
                    vm.servantList = servants;
                    if (vm.servantList && vm.servantList.length > 0) {
                        vm.selectedServant = vm.servantList[0];
                        if (then)
                            then();
                    } else {

                    }
                });
            }
        }

        function getAllActiveServants() {
            ServantCustom.findServantsByCompany().query(function (list) {
                vm.allServants = list;
            })
        }

        function addServiceItem() {
            if (!vm.selectedServiceItem)
                return;

            var item = {};
            item.title = vm.selectedServiceItem.itemTitle;
            item.type = vm.itemSelectionType;
            item.description = "";
            item.price = vm.selectedServiceItem.minPrice; //vm.itemPrice;
            item.qty = 1; //vm.itemQty;
            // item.discount = 0;
            // item.vat = 0;
            item.totalRowPrice = computeRowTotalPrice(item);

            item.referencedItemId = vm.selectedServiceItem.id;

            item.randomNo = Math.floor(Math.random() * 10000);

            if (vm.selectedServant) {
                item.servant = vm.selectedServant;
                item.servantName = vm.selectedServant.personInfo.fullName;
            }

            if (vm.servantList)
                item.availableServants = vm.servantList;

            vm.invoiceInfoItems.push(item);


            resetSelectedItems();
        }


        function computeRowTotalPrice(item) {
            var total = 0;
            if (item && item.price && item.qty) {
                total = item.price && item.qty;
                if (item.discount)
                    total = total - item.discount;
            }

            return total;
        }

        function resetSelectedItems() {
            vm.selectedServiceItem = null;
        }

        function onServiceItemClick(serviceItem) {

            vm.selectedServiceItem = serviceItem;
        }

        function onServiceAddOnClick(addOn) {
            addServiceAddOn(addOn);
        }

        function addServiceAddOn(addOn) {

            if (!addOn)
                return;

            var item = {};
            item.title = addOn.title;
            item.type = vm.itemSelectionType;
            item.description = "";
            item.price = addOn.price;
            item.qty = 1;
            // item.discount = 0;
            // item.vat = 0;
            item.totalRowPrice = computeRowTotalPrice(item);
            item.referencedItemId = addOn.id;
            item.randomNo = Math.floor(Math.random() * 10000);

            if (vm.allServants)
                item.availableServants = vm.allServants;

            vm.invoiceInfoItems.push(item);
        }

        function deleteItem(item) {
            vm.invoiceInfoItems = vm.invoiceInfoItems.filter(function (invoiceItem) {
                if (invoiceItem.randomNo != item.randomNo) {
                    return invoiceItem;
                }

            })

        }

        function getAllServiceAddOns() {
            ServiceAddOnCustom.getActiveServiceAddOns().query(function (list) {
                vm.serviceAddOnList = list;
            })

        }

        function tabChanged(tabName) {
            if (tabName == 'serviceAddOnTab')
                vm.itemSelectionType = 'SERVICE_ADD_ON';
            else
                vm.itemSelectionType = 'SERVICE';

        }

        function goToServiceAddOn() {
            $state.go('supplierPanel-v2.serviceAddOnList');
            closeModal();
        }

        $scope.$watch('vm.selectedServiceItem', function () {

            if (!vm.selectedServiceItem) {
                vm.servantList = [];
                vm.selectedServant = [];

                var elem = document.getElementById("serviceListId");
                if (elem)
                    elem.focus();

                return;
            }
            updateServantList(addServiceItem);


            //set default price
            // in future must read from servant price too

            if (vm.selectedServiceItem.minPrice)
                vm.itemPrice = vm.selectedServiceItem.minPrice;
            else
                vm.itemPrice = 0;

            vm.itemQty = 1;

        })

    }
})();
